<template>
  <div class="page">

      <div class="container">
        <div class="row">
          <h6 class="center-align">{{ $t("SETTINGS.SETTINGS") }}</h6>
          <p>{{ $t("SETTINGS.SETTINGS-LINK") }}: <a :href="url" target="_blank">{{url}}</a> </p>
        </div>
      </div>

  </div>
</template>

<script>
import Bus from '@/components/ControlBus'
import { enviroment } from '@/utils/constants'

export default {
  name: 'Info',
  mounted: function () {
    // keys control
    Bus.$on('key-back', this.keyBack)
  },
  methods: {
    keyBack () { this.$router.go(-1) }
  },
  computed: {
    url: function () {
      if (this.$store.getters.getData.login_url) {
        return this.$store.getters.getData.login_url
      }
      let env = enviroment
      if (enviroment === 'api' || enviroment === 'api-pinko') { env = 'portal' }
      return 'https://' + env + '.interactvty.com/tv/' + this.$store.getters.getData.name + '/'
      // return '#/browser-register'
    }
  },
  beforeDestroy: function () {
    Bus.$off('key-back', this.keyBack)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.container
  color: #424242

  .row
    text-align: center

    h6
      font-size: 2.6rem

    p
      font-size: 1.5rem
      margin-top: 5rem

      a
        font-weight: bold;
        color: inherit;

    span
      position: absolute
      bottom: 0
      right: 0
      margin: 3rem
</style>



// WEBPACK FOOTER //
// src/pages/settings/settings-user.vue